<template>
	<div class="msg-release overFlowXauto">
		<div class="left-tree">
			<Tree @changeSwitch="changeSwitch" :switchVal="switchVal" @nodeClick="nodeClick"></Tree>
		</div>
		<div class="right-content">
			<div class="right-content-top"  style="width:calc(100vw - 560px)">
				<div id="pie1" style="width: 50%;height: 300px;"></div>
				<div id="pie2" style="width: 50%;height: 300px;"></div>
			</div>
			<div class="right-content-bottom"  style="width:calc(100vw - 560px)">
				<el-table :data="tableData" style="width:100%">
					<el-table-column prop="areaName" label="区域">
					</el-table-column>
					<el-table-column label="应急发布">
						<el-table-column prop="broadcast" label="应急广播">
						</el-table-column>
						<el-table-column prop="msg" label="系统公告">
						</el-table-column>
					</el-table-column>
					<el-table-column label="雪亮发布">
						<el-table-column prop="conBuild" label="微党建">
						</el-table-column>
						<el-table-column prop="conServer" label="微服务">
						</el-table-column>
						<el-table-column prop="conPublicize" label="微宣传">
						</el-table-column>
						<el-table-column prop="conPower" label="微权力">
						</el-table-column>
						<el-table-column prop="conPopular" label="微民情">
						</el-table-column>
						<el-table-column prop="conBroadcast" label="微播报">
						</el-table-column>
						<el-table-column prop="conPoverty" label="微扶贫">
						</el-table-column>
						<el-table-column prop="conTravel" label="微旅游">
						</el-table-column>
					</el-table-column>
				</el-table>
				<el-pagination :style="{textAlign:'right'}" :small="false" @size-change="pagination.sizeChange" @current-change="pagination.pageChange"
				 :current-page="pagination.page || 1" :page-sizes="pagination.pageSizes || [5]" :page-size="pagination.size || 5"
				 layout="total, sizes, prev, pager, next, jumper" :total="pagination.total || 0">
				</el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
	import echarts from 'echarts';
	import Tree from '../../../../components/Tree/nodeTree';
	import {
		xlSasApi
	} from '../../../../api-path/xl-api.js'
	export default {
		components: {
			Tree
		},
		data() {
			return {
				switchVal: false,
				searchParams: {
					isDown: false,
					areaId: '',
					page: 1,
					size: 5,
				},
				pagination: {
					total: 0,
					page: 1,
					size: 5,
					sizeChange: this.sizeChange,
					pageChange: this.pageChange,
				}, // 分页
				tableData: [],
				searchParams2: {
					isDown: false,
					areaId: '',
				},
			}
		},
		methods: {
			changeSwitch(e) {
				this.switchVal = e;
				this.searchParams.isDown = e;
				this.searchParams2.isDown = e;
        if (this.searchParams.areaId === '' || this.searchParams2.areaId === '' || this.searchParams.areaId === null || this.searchParams2.areaId === null) {
          this.$message.info("请选择对应的区域!");
          return ;
        }
				this.setSearchParams();
				this.setSearchParams2()
			},
			nodeClick(node) {
				this.searchParams.areaId = node.id;
				this.searchParams2.areaId = node.id;
        if (this.searchParams.areaId === '' || this.searchParams2.areaId === '' || this.searchParams.areaId === null || this.searchParams2.areaId === null) {
          this.$message.info("请选择对应的区域!");
          return ;
        }
				this.setSearchParams();
				this.setSearchParams2()
			},
			// 每页显示条数
			sizeChange(size) {
				this.searchParams.size = this.pagination.size = size;
        if (this.searchParams.areaId === '' ||  this.searchParams.areaId === null ) {
          this.$message.info("请选择对应的区域!");
          return ;
        }
				this.setSearchParams()
			},
			// 当前页
			pageChange(page) {
				this.searchParams.page = this.pagination.page = page;
        if (this.searchParams.areaId === '' ||  this.searchParams.areaId === null ) {
          this.$message.info("请选择对应的区域!");
          return ;
        }
				this.setSearchParams()
			},
			setSearchParams() {
				//查询列表
				this.$http.get(xlSasApi.queryStatisticsMsg, {
					params: this.searchParams
				}).then(res => {
					if (res.status == 200) {
						this.tableData = res.result.pageList;
						this.pagination.total = res.result.total;
					}
				})
			},
			setSearchParams2() {
				//查询图表数据
				this.$http.get(xlSasApi.statisticsMsg, {
					params: this.searchParams2
				}).then(res => {
					if (res.status == 200) {
						let data = res.result;
						let barXAxisData = [{
								name: '应急广播',
								value: data.broadcast
							},
							{
								name: '系统公告',
								value: data.msg
							}
						];
						let pieXAxisData = [{
								name: '微党建',
								value: data.conBuild
							},
							{
								name: '微服务',
								value: data.conServer
							},
							{
								name: '微宣传',
								value: data.conPublicize
							},
							{
								name: '微权力',
								value: data.conPower
							},
							{
								name: '微民情',
								value: data.conPopular
							},
							{
								name: '微播报',
								value: data.conPoverty
							},
							{
								name: '微扶贫',
								value: data.conPower
							},
							{
								name: '微旅游',
								value: data.conTravel
							}
						]

						this.chartPie1(barXAxisData)
						this.chartPie2(pieXAxisData)
					}
				})
			},
			//绘制饼图
			chartPie1(pieXAxisData) {
				// 基于准备好的dom，初始化echarts实例
				let myChart = echarts.init(document.getElementById('pie1'))
				// 绘制图表
				myChart.setOption({
					title:{
						show:true,
						text:'应急发布',
						textStyle:{
							color:'#999'
						}
					},
					legend: {
						type: 'plain',
						orient: 'horizontal',
						right: 'center',
						bottom: 0,
						data: [ '应急广播','系统公告'],
					},
					series: [{
						color: ['#6cb8d8', '#434abf', '#ff9338', '#fe6a7a', '#ffc621'],
						name: '区域用户类型',
						type: 'pie',
						radius: [0, 100],
						center: ['50%', '50%'],
						roseType: 'radius',
						itemStyle:{ 
							normal:{ 
							   label:{ 
									position:'inside',
									show: true, 
									fontWeight:"bold",
									fontSize:16,
									formatter: '{c}' 
								}, 
								labelLine :{show:true} 
							} 
						},
						data: pieXAxisData
					}]
				})

			},
			//绘制饼图
			chartPie2(pieXAxisData) {
				// 基于准备好的dom，初始化echarts实例
				let myChart = echarts.init(document.getElementById('pie2'))
				// 绘制图表
				myChart.setOption({
					title:{
						show:true,
						text:'雪亮发布',
						textStyle:{
							color:'#999'
						}
					},
					legend: {
						type: 'plain',
						orient: 'horizontal',
						right: 'center',
						bottom: 0,
						data: ['微党建', '微服务', '微宣传', '微权力', '微民情','微播报','微扶贫','微旅游'],
					},
					series: [{
						color: ['#6cb8d8', '#434abf', '#ff9338', '#fe6a7a', '#ffc621'],
						type: 'pie',
						radius: [0, 100],
						center: ['50%', '50%'],
						roseType: 'radius',
						itemStyle:{ 
							normal:{ 
							   label:{ 
									position:'inside',
									show: true, 
									fontWeight:"bold",
									fontSize:16,
									formatter: '{c}' 
								}, 
								labelLine :{show:true} 
							} 
						},
						data: pieXAxisData
					}]
				})

			},
			
		}
	}
</script>

<style lang="less" scoped>
	.msg-release {
		margin-left: 10px;
		box-sizing: border-box;
		height: 100%;
		width: 100%;
		padding: 10px;
		border-radius: 10px;
		background: #fff;
		display: flex;

		.left-tree {
			margin-right: 10px;
			border-right: 1px solid #c1c1c1;
		}

		.right-content {
			flex: 1;
			width: 100%;
			display: flex;
			flex-direction: column;
			align-items: center;
			.right-content-top {
				display: flex;
				
				justify-content: space-around;
				padding: 40px 0;
				border-bottom: 10px solid #f1f4fb;
				margin-bottom: 40px;
			}

			.right-content-bottom {
				width: 100%;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
			}
		}
	}
</style>
